import React from 'react';
import { observer } from 'mobx-react-lite';
import { InputText } from '@insurancemenu/imenu-components-lib';
import { FormControl, StandardFormChangeEvent } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { createStyles } from './styles';
import { GROUP_INFO_FORM_TEST, MAIN_CONTACT_INFO_TEST } from '../constants';

interface MainContactInformationProps {
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  primaryPhone: FormControl<string>;
  primaryEmail: FormControl<string>;
  title: FormControl<string>;
  onChange: (e: StandardFormChangeEvent) => void;
}

const MainContactInformation: React.FC<MainContactInformationProps> = observer(
  ({ firstName, lastName, primaryPhone, primaryEmail, title, onChange }) => {
    const classes = createStyles();
    return (
      <div data-test-id={MAIN_CONTACT_INFO_TEST}>
        <p className={classes.category}>Main Contact Information</p>
        <div className={classes.inputContainer}>
          <InputText
            label="First Name"
            name="firstName"
            value={firstName.value}
            className={classes.halfInputLayout}
            onChange={onChange}
            validationPassed={!firstName.unpassedValidationMsg}
            validationMessage={firstName.unpassedValidationMsg || ''}
            maxLength={100}
            data-test-id={GROUP_INFO_FORM_TEST.firstName}
          />
          <InputText
            label="Last Name"
            name="lastName"
            value={lastName.value}
            className={classes.halfInputLayout}
            onChange={onChange}
            validationPassed={!lastName.unpassedValidationMsg}
            validationMessage={lastName.unpassedValidationMsg || ''}
            maxLength={100}
            data-test-id={GROUP_INFO_FORM_TEST.lastName}
          />
          <InputText
            label="Phone Number"
            name="primaryPhone"
            value={primaryPhone.value}
            className={classes.halfInputLayout}
            onChange={onChange}
            validationPassed={!primaryPhone.unpassedValidationMsg}
            validationMessage={primaryPhone.unpassedValidationMsg || ''}
            maxLength={10}
            data-test-id={GROUP_INFO_FORM_TEST.primaryPhone}
          />
          <InputText
            label="Title"
            name="title"
            value={title.value}
            className={classes.halfInputLayout}
            onChange={onChange}
            validationPassed={!title.unpassedValidationMsg}
            validationMessage={title.unpassedValidationMsg || ''}
            data-test-id={GROUP_INFO_FORM_TEST.title}
          />
          <InputText
            label="Email Address"
            name="primaryEmail"
            value={primaryEmail.value}
            className={classes.fullInputLayout}
            onChange={onChange}
            validationPassed={!primaryEmail.unpassedValidationMsg}
            validationMessage={primaryEmail.unpassedValidationMsg || ''}
            data-test-id={GROUP_INFO_FORM_TEST.primaryEmail}
          />
        </div>
      </div>
    );
  },
);

export default MainContactInformation;
